import Text from "../../../../components/ui/Text";
import { useTalkieWalkie } from "../../hooks/use-talkie-walkie";
import Button from "../ui/Button";
import starFullImage from "../../assets/images/star-full.png";
import starEmptyImage from "../../assets/images/star-empty.png";
import { useMemo } from "react";
import disconnectSound from "../../../../assets/audio/disconnect.wav";
import { useAudioEffects } from "../../../../hooks/use-audio-effects";

interface WalkieTalkieMenuProps {
  className?: string;
  title?: string;
  onSettingsClick?: () => void;
  onDisconnectClick?: () => void;
}

const WalkieTalkieMenu = ({
  className = "",
  title = "Connected to",
  onSettingsClick = () => {},
  onDisconnectClick = () => {},
}: WalkieTalkieMenuProps) => {
  const {
    activeChannel,
    favoriteChannels,
    removeChannelFromFavorites,
    addChannelToFavorites,
    disconnect,
    setActiveScreen,
  } = useTalkieWalkie();
  const { playEffect } = useAudioEffects();
  const isChannelFavorited = useMemo(
    () => favoriteChannels.some((fc) => fc.id === activeChannel?.id),
    [activeChannel, favoriteChannels]
  );

  function toggleFavorite() {
    if (!activeChannel) return;

    if (isChannelFavorited) {
      removeChannelFromFavorites(activeChannel);
    } else {
      addChannelToFavorites(activeChannel);
    }
  }

  return (
    <div
      className={`h-full flex flex-col justify-center items-center ${className}`}
    >
      <Text
        size="sm"
        className="!font-semibold text-[#BEB9FF] text-center mb-1 mt-[-50px]"
      >
        {title}
      </Text>

      {/** Active Channel, Settings & Disconnect */}
      <div className="w-full space-y-2">
        {/** Channel */}
        <Button
          onClick={() => {}}
          variant="neutral"
          className="w-fullrounded-md "
        >
          <div className="flex items-center justify-between">
            <span className="w-[18px]"></span>{" "}
            <Text size="xxs" className="text-[#8795FF]">
              {activeChannel?.mhz} mHZ
            </Text>
            <div
              onClick={toggleFavorite}
              className="bg-[#566AFF29] p-1 rounded-md"
            >
              <img
                className="w-[11px] h-[11px]"
                alt="Star"
                src={isChannelFavorited ? starFullImage : starEmptyImage}
              />
            </div>
          </div>
        </Button>

        {/** Settings */}
        <Button
          onClick={() => {
            setActiveScreen("settings");
            onSettingsClick();
          }}
          variant="yellow"
          className="rounded-md"
        >
          <Text size="xxs" className="text-white">
            Settings
          </Text>
        </Button>

        {/** Disconnect */}
        <Button
          onClick={() => {
            disconnect();
            onDisconnectClick();
            playEffect(disconnectSound);
          }}
          disableAudioEffect
          variant="red"
          className="rounded-md"
        >
          <Text size="xxs" className="text-white">
            Disconnect
          </Text>
        </Button>
      </div>
    </div>
  );
};

export default WalkieTalkieMenu;
